import(/* webpackMode: "eager" */ "/app/src/app/forum/page.tsx");
